export const collaboratorsLocale = {
   title: 'Соавторы',
   code: "промо-код",
   link: "ссылка",
   number_people_invited: "количество приглашенных пользователей",
   level: "Уровень",
   balance_received: "баланс полученных средств",
   register_withdraw: "зарегистрировать вывод средств",
   list_user_invite: 'список приглашенных пользователей',
   search: 'поиск',
   stt: 'STT',
   time: 'Время',
   mail: 'почта',
   kyc: 'проверка личности',
   withdrawal_history: 'история выводов средств',
   amount: 'сумма',
   token_type: 'Тип токена',
   status: 'статус',
   register_title: 'Зарегистрироваться в качестве соавтора',
   register_content: 'Нажав кнопку ниже, вы соглашаетесь принять участие в программе соавторов AIS.',
   confirm_register: 'подтвердить',
   close_register: 'отменить',
   withdraw_all: 'Вывести все',
   withdraw_landmark: 'Вывод по метке',
   money: 'Деньги',
   money_remaining: 'Осталось',
   withdrawal_fee: 'Комиссия за вывод',
   bonus_draw_milestone: 'метка для бонуса (реферер)',
   withdraw_content: 'Пользователь может выбрать вывод средств в соответствии с текущим уровнем или полной суммой заработанных средств. При выводе средств уровень и количество рефералов сбрасываются. При полном выводе средств взимается комиссия в размере 2000 STN-A.',
   unknown_error: 'Произошла ошибка, пожалуйста, попробуйте еще раз.',
   oops: 'Ой!',
   ok: 'OK',
};
